// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconUsdg } from "../../../icons/mono/build/icon-usdg.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const UsdgIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconUsdg.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  UsdgIcon.displayName = 'UsdgIcon';
}

export default UsdgIcon;